import React, { useState, useEffect } from 'react'

import { ICatalogItem, IGoods, IBreadcrumb } from 'interfaces'
import { APP_URL } from 'config/app'
import { Breadcrumbs } from 'components'
import { parseTpl } from 'utils/helpers'

type ShopBreadcrumbsPropType = {
    storeId: number
    catalogId: number
    categories?: ICatalogItem[]
    goods?: IGoods
}

const StoreBreadcrumbs: React.FC<ShopBreadcrumbsPropType> = ({
    storeId,
    catalogId,
    categories = [],
    goods,
}) => {
    const [breadcrumbs, setBreadcrumbs] = useState<IBreadcrumb[]>([])

    function getBreadcrumbUrl(id: number): string {
        return parseTpl(APP_URL.catalog, {
            ':id': storeId,
            ':catalogId': id,
        }, {
            prefix: '',
            suffix: '',
        })
    }

    useEffect(() => {
        if (catalogId && categories.length) {
            const crumbs: IBreadcrumb[] = []
            let category = categories.find((item) => item.id === Number(catalogId))

            if (goods) {
                crumbs.push({ id: goods.id, name: goods.name })
            }

            while (category) {
                const {
                    id,
                    name,
                    view_type,
                    parent,
                } = category

                if (view_type === 2) {
                    crumbs.push({
                        id,
                        name,
                        url: (!goods && id !== Number(catalogId)) || goods ? getBreadcrumbUrl(id) : '',
                    })
                }

                if (parent) {
                    category = categories.find((item) => item.id === parent)
                } else {
                    category = undefined
                }
            }

            setBreadcrumbs(crumbs.reverse())
        }
    }, [catalogId, categories])

    return <Breadcrumbs items={breadcrumbs} />
}

export default StoreBreadcrumbs
